import React, { useState, useRef } from 'react';
import { Image, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import styles from './CustomImage.module.css';
import { downloadFile } from '../../App/Utilities';
import { showCustomToast } from '../../../utils/addImageDownload';

export const CustomImage = ({ src, preview, ...props }) => {
  const [internalPreviewVisible, setInternalPreviewVisible] = useState(false);
  const previewContainerRef = useRef(null);
  
  // If preview is explicitly set to false, disable preview entirely
  if (preview === false) {
    return <Image {...props} src={src} preview={false} />;
  }
  
  // Use the visible prop from parent if provided, otherwise use internal state
  const isPreviewVisible = props.preview?.visible !== undefined ? props.preview.visible : internalPreviewVisible;


  const handleDownload = () => {
    showCustomToast();
    const link = document.createElement('a');
    link.href = props.preview?.src || src; 
    link.download = props.fileName || 'downloaded-image'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const addDownloadButton = () => {
    setTimeout(() => {
      if (previewContainerRef.current) {
        const toolbar = previewContainerRef.current.querySelector('.ant-image-preview-operations');
        if (toolbar && !toolbar.querySelector('.download-btn')) {
          const downloadBtn = document.createElement('div');
          downloadBtn.className = 'ant-image-preview-operations-operation download-btn';
          downloadBtn.onclick = handleDownload;

          const downloadIcon = document.createElement('span');
          downloadIcon.role = 'img';
          downloadIcon.ariaLabel = 'download';
          downloadIcon.className = 'anticon anticon-download';
          downloadIcon.className = 'anticon anticon-download ant-image-preview-operations-icon';


          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '64 64 896 896');
          svg.setAttribute('focusable', 'false');
          svg.setAttribute('data-icon', 'download');
          svg.setAttribute('width', '1.4em');
          svg.setAttribute('height', '1.4em');
          svg.setAttribute('fill', 'currentColor');
          svg.setAttribute('aria-hidden', 'true');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M505.7 661a8 8 0 0012.6 0l112-141.7a8 8 0 00-9.4-12.5h-71.3v-192c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v192h-71.3a8 8 0 00-9.4 12.5l112 141.7zM294 824h436c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H294c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8z');

          svg.appendChild(path);
          downloadIcon.appendChild(svg);
          downloadBtn.appendChild(downloadIcon);
          toolbar.appendChild(downloadBtn);
        }
      }
    }, 100);
  };

  return (
    <>
      <Image
        {...props}
        src={src}
        preview={{
          src: props.preview?.src || src,
          visible: isPreviewVisible,
          onVisibleChange: (vis) => {
            // If parent is controlling visibility, call parent's onVisibleChange
            if (props.preview?.visible !== undefined && props.preview?.onVisibleChange) {
              props.preview.onVisibleChange(vis);
            } else {
              // Otherwise, use internal state
              setInternalPreviewVisible(vis);
            }
            if (vis) {
              addDownloadButton();
            }
          },
          getContainer: () => {
            if (!previewContainerRef.current) {
              previewContainerRef.current = document.createElement('div');
              document.body.appendChild(previewContainerRef.current);
            }
            return previewContainerRef.current;
          },
        }}
      />
    </>
  );
};

